import NoResults from "components/Organisms/NoResults"
import React from "react"
import CustomButton from "./CustomButton"
class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: {},
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
  }

  render() {
    const { hasError, error } = this.state

    if (hasError) {
      return (
        <div className="vt-crash-screen h-full w-full flex flex-col justify-center items-center p-5">
          <NoResults
            action={
              <CustomButton
                onClick={e => (window.location.pathname = "/d")}
                dark={true}
                icon="home"
              >
                Home
              </CustomButton>
            }
            icon="error"
            title="Something went wrong!"
            description={
              <p className="vt-crash-description">{error.message}</p>
            }
          />
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
